import React from "react";
import {isString} from "../../Utilities/Types/typeUtilities";
import {HtmlDisplay} from "../Display";
import {DisplayLayout} from "./DisplayLayout";

interface DisplayFieldProps {
    children?: React.ReactNode;
    displayClass?: string;
    label: string;
    isScrolling?: boolean;
    medium_columns?: string;
    name: string;
    value?: string;
    isDisabled?: boolean;
}

export const DisplayField: React.FC<DisplayFieldProps> = ({
                                 children,
                                 displayClass,
                                 label,
                                 isScrolling,
                                 medium_columns,
                                 name,
                                 value,
                                 isDisabled = true
                             }: DisplayFieldProps) => {
    const htmlValue = children || value;
    const isHtml = isString(htmlValue);
    const overflowClass = isScrolling ? "input__text--scroll" : "input__text--wrap";
    const disabledClass = isDisabled ? `is-disabled` : ``;
    const classes = `input__text ${disabledClass} ${displayClass} ${overflowClass}`;

    return (
        <DisplayLayout medium_columns={medium_columns} label={label} name={`${name}_container`}>
            {
                isHtml &&
                <HtmlDisplay className={classes} name={name} html={htmlValue as string}/>
            }
            {
                !isHtml &&
                <div id={name} data-testid={name} className={classes}>
                    {children}
                </div>
            }
        </DisplayLayout>
    );
};
